import { CartUpdateEvent } from "@gob/events";

class ComponentCartSubtotal extends HTMLElement {
  constructor() {
    super();

    this.el = this;
    this.cart = null;
    
    document.addEventListener(CartUpdateEvent.eventName, this.handleCartUpdate.bind(this));
  }

  handleCartUpdate(event) {
    this.cart = event.cart;

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    this.el.textContent = formatter.format(this.cart.total_price / 100);
  }
}

if (!customElements.get('cart-subtotal')) {
  customElements.define('cart-subtotal', ComponentCartSubtotal);
}